<template>
    <iframe v-if="isPdf" :src="pdfURL" class="pdfStyle"></iframe>
    <div ref="document" v-else></div>

</template>

<script>
import {getReport} from '@/api/index'
import {renderAsync} from 'docx-preview';
Window.JSZip = require('jszip')
    export default {
        data() {
            return {
                filename : '',
                isWord : false,
                isPdf : false,
                pdfURL : '',
            }
        },
        mounted() {
           let index = location.search.indexOf('=');
           this.filename = location.search.slice(index + 1);

           this.documentPreview(this.filename)
        },
        methods: {
            documentPreview(fileName) {
                getReport(fileName).then(res => {
                    if(res.info == "token不正确!" || res.info == "token已过期,请重新获取!") {
                    this.$message.info(res.info);
                    localStorage.clear();
                    window.location = '/login'
                 }
                    if(res.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
                    //    this.isPdf = false;
                    //    let url = new Blob([res]);
                    //    console.log(URL.createObjectURL(url));
                    //    window.open(URL.createObjectURL(res))
                    //    console.log(res)
                       setTimeout(()=> {
                       renderAsync(res,this.$refs.document);
                       },1000)
                    //    const blob = new Blob([res]);
                    }
                    else {
                         this.isPdf = true;
                         this.isWord = false;
                         let file = URL.createObjectURL(res);
                         this.pdfURL = file;
                    }
                }).catch(err => {
                    this.$message.info(err);
                })
            }
        }
    }
</script>

<style scoped>
.pdfStyle {
    width: 100%;
    height : 100vh;
}
</style>